import { render } from "./TeamOkrs.vue?vue&type=template&id=a508ecd8&scoped=true"
import script from "./TeamOkrs.vue?vue&type=script&lang=js"
export * from "./TeamOkrs.vue?vue&type=script&lang=js"

import "./TeamOkrs.vue?vue&type=style&index=0&id=a508ecd8&scoped=true&lang=css"

import exportComponent from "/var/www/compass/production/releases/20251103101657/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a508ecd8"]])

export default __exports__